import PropTypes from 'prop-types'
import React, { useState } from 'react'

import Modal from '../../app/customModal/Modal'

const ApproveVesselPopup = props => {
  const [inputIsActive, setInputIsActive] = useState(false)
  const [approvedBy, setApprovedBy] = useState('')

  return (
    <>
      <Modal.Content>
        <div>Who approved releasing the vessel?</div>
        <p>
          <input
            value={approvedBy}
            className="prompt-popup-input input-field"
            onChange={e => setApprovedBy(e.target.value)}
            ref={ref => {
              if (ref && !inputIsActive) {
                if (props.defaultValue) {
                  ref.value = props.defaultValue
                }
                setInputIsActive(true)
                setTimeout(() => ref.select()) // focus to input field
              }
            }}
            onKeyPress={event => {
              if (event.key === 'Enter') {
                props.approveBlockedVessel(approvedBy)
              }
            }}
          />
        </p>
      </Modal.Content>

      <Modal.Buttons>
        <button className="btn" onClick={() => props.approveBlockedVessel(approvedBy)}>
          Approve
        </button>
      </Modal.Buttons>
    </>
  )
}

ApproveVesselPopup.propTypes = {
  approveBlockedVessel: PropTypes.func.isRequired,
  defaultValue: PropTypes.string
}

export default ApproveVesselPopup
